<script setup lang="ts">
import { computed } from 'vue'

import AutomationGroupStayListValidationButton from '@/automation/stay-list/AutomationGroupStayListValidationButton.vue'
import { hasPermission, RoleEnum } from '@/misc/permissions/permissionsHelper'
import ExportStayListButton from '@/stay-list/stay-list-table/actions/ExportStayListButton.vue'
import ReadingListButton from '@/stay-list/stay-list-table/actions/ReadingListButton.vue'
import StayListActions from '@/stay-list/stay-list-table/actions/StayListActions.vue'
import { ListMcoStay } from '@/stay-list/stay-list-table/mco/types'
import { useStore } from '@/store'
import { ModeEnum, PmsiTypeEnum } from '@/store/modules/settings/types'

const store = useStore()

const userRole = store.state.login.userRole

const stayList = computed(() => store.state.automation.automationStayList.items.map((stay: ListMcoStay) => stay.id))
const emit = defineEmits<{
  (e: 'refresh-staylist')
  (e: 'set-stay-list-parameter', type: string, value: number | boolean)
}>()

const exportRequest = computed(() => store.getters.getAutomationGroupStayListExportRequest)

const params = computed(() => ({
  showSeen: store.state.automation.automationStayListParams.showSeen,
  pageSize: store.state.automation.automationStayListParams.pageSize
}))
</script>

<template>
  <stay-list-actions
    :params="params"
    @set-stay-list-parameter="(type, value) => emit('set-stay-list-parameter', type, value)"
  >
    <span
      v-if="hasPermission(RoleEnum.ROLE_STAY_BULK_VALIDATOR, userRole)"
    >
      <automation-group-stay-list-validation-button
        @refresh-staylist="emit('refresh-staylist')"
      />
    </span>
    <export-stay-list-button
      :mode="ModeEnum.AUTOMATION"
      :request="exportRequest"
    />
    <reading-list-button
      :mode="ModeEnum.AUTOMATION"
      :pmsi-type="PmsiTypeEnum.MCO"
      :stay-list="stayList"
    />
  </stay-list-actions>
</template>
